<template>
  <modal name="add-rate" height="auto" width="500px" :scrollable="true" :shiftY="0.2" @closed="close" :clickToClose="!loading">
    <div class="close" v-if="!loading">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('add-rate')"  alt="">
    </div>
    <div class="modal-form">
      <div style="text-align: center">
        <h3>Вы уверены, что хотите удалить сотрудника?</h3>
      </div>
      <div style="padding: 10px;text-align: center">
        <span> Это действие необратимо</span>
      </div>
      <div class="input-block" v-if="position == 'Менеджер по закупкам' && show_select">
        <h4>{{'Заменить менеджер по закупкам на'}}</h4>
        <app-select :options="purchaser_managers"
                    data-vv-as="менеджер по закупкам"
                    v-validate.persist="'required'"
                    v-model="purchaser_manager"
                    name="purchaser_manager"
                    label="name"
                    :placeholder="'Менеджер по закупкам'"/>
        <span class="text-danger text-sm">{{ errors.first('purchaser_manager') }}</span>
      </div>
      <div class="input-block" v-if="position == 'Старший менеджер по закупкам' && show_select">
        <h4>{{'Заменить старшего менеджера по закупкам на'}}</h4>
        <app-select :options="senior_purchaser_managers"
                    v-validate.persist="'required'"
                    v-model="senior_purchaser_manager"
                    name="senior_purchaser_manager"
                    data-vv-as="старший менеджер по закупкам"
                    label="name"
                    :placeholder="'Старший менеджер по закупкам'"/>
        <span class="text-danger text-sm">{{ errors.first('senior_purchaser_manager') }}</span>
      </div>
      <div class="input-block" v-if="position == 'Менеджер по продажам' && show_select">
        <h4>{{'Заменить менеджера по продажам на'}}</h4>
        <app-select :options="sale_managers"
                    v-model="sale_manager"
                    v-validate.persist="'required'"
                    name="sale_manager"
                    data-vv-as="менеджер по продажам"
                    label="name"
                    :placeholder="'Менеджер по продажам'"/>
        <span class="text-danger text-sm">{{ errors.first('sale_manager') }}</span>
      </div>
      <div class="input-block" v-if="position == 'Менеджер клиентской поддержки' && show_select">
        <h4>{{'Заменить менеджера клиентской поддержки на'}}</h4>
        <app-select :options="support_managers"
                    v-model="support_manager"
                    v-validate.persist="'required'"
                    name="support_manager"
                    label="name"
                    data-vv-as="менеджер клиентской поддержки"
                    :placeholder="'Менеджер клиентской поддержки'"/>
        <span class="text-danger text-sm">{{ errors.first('support_manager') }}</span>
      </div>
      <div class="row" style="justify-content: center; margin-top: 30px">
        <button class="btn done" style="margin-right: 10px" v-if="show_button" @click="voteYes">Да</button>
        <button class="btn dont" @click="close">Отмена</button>
      </div>
    </div>
  </modal>
</template>

<script>

import AppSelect from "@/components/app-select";

export default {
  name: "change-user-modal",
  components: {
    AppSelect
  },
  data: ()=> ({
    rate:[],
    comment: '',
    id: null,
    loading: false,
    options: [],
    type: '',
    sale_managers: [],
    support_managers: [],
    sale_manager: '',
    support_manager: '',
    purchaser_managers: [],
    senior_purchaser_managers: [],
    purchaser_manager: '',
    senior_purchaser_manager: '',
    position: '',
    show_select: 0,
    show_button: 0
  }),
  mounted() {

  },
  methods: {
    open(worker = null){
      if(worker == null) return console.error('[add-rate-modal:open] prop id required!')
      this.id = worker.id;
      this.type = localStorage.getItem('type');
      this.position = worker.position;
      if (this.position == 'Менеджер клиентской поддержки' ||
              this.position == 'Менеджер по продажам' ||
              this.position == 'Менеджер по закупкам' ||
              this.position == 'Старший менеджер по закупкам') {
        this.getCheckUserContract();
      } else {
        this.show_button = 1;
      }
      this.$modal.show('add-rate');
    },
    close(){
      this.id = this.comment = null;
      this.rate = []
      this.support_managers = [];
      this.sale_managers = [];
      this.purchaser_managers = [];
      this.senior_purchaser_managers = [];
      this.position = '';
      this.purchaser_manager = '';
      this.senior_purchaser_manager = '';
      this.show_select = 0;
      this.show_button = 0;
      this.$modal.hide('add-rate')
    },
    voteYes(){
      this.$validator.validateAll()
          .then(success => {
            if(success){
              this.$emit('saved', {
                id: this.id,
                sale_manager: this.sale_manager ?  this.sale_manager.id : '',
                support_manager: this.support_manager ?  this.support_manager.id : '',
                purchaser_manager: this.purchaser_manager ?  this.purchaser_manager.id : '',
                senior_purchaser_manager: this.senior_purchaser_manager ?  this.senior_purchaser_manager.id : '',
              });
              this.$modal.hide('add-rate');
              this.id = this.comment = null;
              this.support_managers = [];
              this.sale_managers = [];
              this.purchaser_managers = [];
              this.senior_purchaser_managers = [];
              this.position = '';
              this.purchaser_manager = '';
              this.senior_purchaser_manager = '';
              this.show_select = 0;
              this.show_button = 0;
              this.rate = []
            }
      })
    },
    getUsers() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-users', {
          token: localStorage.getItem('token')
        }).then(({data}) => {
          if (data.users) {
            this.support_managers = [];
            this.sale_managers = [];
            this.purchaser_managers = [];
            this.senior_purchaser_managers = [];
            for(const key in data.users) {
              data.users[key].name = data.users[key].surname + ' ' + data.users[key].name;
              if (this.type == 1) {
                if ((data.users[key].position == 'Менеджер клиентской поддержки' || data.users[key].position == 'Руководитель отдела' || !data.users[key].supervisor) && data.users[key].id != this.id) {
                  this.support_managers.push(data.users[key]);
                }
                if ((data.users[key].position == 'Менеджер по продажам' || data.users[key].position == 'Руководитель отдела' || !data.users[key].supervisor) && data.users[key].id != this.id) {
                  this.sale_managers.push(data.users[key]);
                }
              } else {
                if ((data.users[key].position == 'Менеджер по закупкам' || data.users[key].position == 'Руководитель отдела' || !data.users[key].supervisor) && data.users[key].id != this.id) {
                  this.purchaser_managers.push(data.users[key]);
                }
                if ((data.users[key].position == 'Старший менеджер по закупкам' || data.users[key].position == 'Руководитель отдела' || !data.users[key].supervisor) && data.users[key].id != this.id) {
                  this.senior_purchaser_managers.push(data.users[key]);
                }
              }
            }
          }
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
    getCheckUserContract() {
      if (localStorage.getItem('token')) {
        this.$http.post('/check-user-contract', {
          token: localStorage.getItem('token'),
          id: this.id
        }).then(({data}) => {
          this.show_select = data.count;
          this.getUsers();
          this.show_button = 1;
        })
        .catch((error) => {
            console.log(error)
        })
      }
    },
  }
}
</script>

<style>
  .v-select ul {
    max-height: 100px;
  }
</style>

<style scoped lang="scss">

.input-block h4 {
  font-size: 12px;
}

.progress-bar-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn{
  width: 40%;
  padding: 0;
  height: 50px;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: none;

}
.done{
  color: #FFFFFF;
  background: #2CB181;
}
.done:hover{
  background: #25966E;
}

.dont{
  border: 1px #000000 solid;
}
.dont:hover{
  background: #e0e0e0;
}
</style>
